export * from './sponsorship-icon';
